import { useQuery } from '@tanstack/vue-query';
import { computed, toValue } from 'vue';
import type { MaybeRefOrGetter } from 'vue';

import { sdk } from '@/sdk';

export const USER_KEYS = {
  all: ['users'] as const,
  list: (params: { includeDeactivated: boolean }) => ['users', 'list', params] as const,
};

export interface UseUsersListOptions {
  includeDeactivated?: MaybeRefOrGetter<boolean | undefined>;
}

export function useUsersList(options: UseUsersListOptions = {}) {
  const includeDeactivated = computed(() => toValue(options.includeDeactivated) ?? false);
  return useQuery({
    queryFn: () => sdk.users.list({ includeDeactivated: includeDeactivated.value }),
    queryKey: computed(() => USER_KEYS.list({ includeDeactivated: includeDeactivated.value })),
    staleTime: 5 * 60 * 1000,
  });
}
